import React, { useState, useRef, useEffect } from 'react';
import { makeStyles, Box, Typography, Button, Collapse } from '@material-ui/core';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import { withTranslation } from 'config/i18n';
import { useLayoutState } from 'components/shared/Layout';

const useStyles = makeStyles((theme) => ({
  text: {
    color: theme.palette.grey['300'],
  },
  textContiner: {
    '& *': {
      padding: '0 !important',
      margin: '0 !important',
    },
  },
}));

const ExpandableDescription = (props) => {
  const classes = useStyles();
  const { t, description, collapsedSize = 80 } = props;
  const { layoutState } = useLayoutState();
  const [isExpanded, setIsExpanded] = useState(layoutState.isCrawler);

  const handleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  const descriptionRef = useRef(null);
  const [descriptionHeight, setDescriptionHeight] = useState(null);

  useEffect(() => {
    setDescriptionHeight(descriptionRef.current.clientHeight);
  }, [descriptionRef, descriptionHeight]);
  return (
    <>
      <Box>
        <Collapse
          in={isExpanded}
          collapsedSize={descriptionHeight < collapsedSize ? descriptionHeight : collapsedSize}
        >
          <Typography className={classes.text} variant="body1" ref={descriptionRef}>
            <div
              className={classes.textContiner}
              dangerouslySetInnerHTML={{ __html: description }}
            />
          </Typography>
        </Collapse>

        {descriptionHeight > collapsedSize && (
          <Button
            color="secondary"
            endIcon={isExpanded ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            onClick={handleExpand}
          >
            {isExpanded
              ? t('fe_es_expandable_description_component:show_less')
              : t('fe_es_expandable_description_component:show_more')}
          </Button>
        )}
      </Box>
    </>
  );
};

export default withTranslation('fe_es_expandable_description_component')(ExpandableDescription);
